import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(theme => ({
  mainDiv: {
    padding: "32px"
  },
  tabDetails: {
    padding: "8px !important"
  },
  agentContainerTabs: {
    display: "flex",
    position: "relative",
    flexDirection: "row",
    width: "100%",
    gap: "12px"
  },
  uiTab: {
    height: "100% !important"
  }
}));

export default styles;
